module.exports = __webpack_public_path__ + "img/microsoft.4be21987.svg";